import { ListingSearchTargetSelect } from "./ListingSearchTargetField";
import type { ListingSearchTarget } from "./listing-search-target";
import { useState } from "react";
import { useMutation } from "@apollo/client/react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router";
import { useValidationFallback } from "@/components/match/use-match-editor";
import { CreateListingDocument } from "@/graphql/generated/operations";
import { userErrorMessage } from "@/lib/user-error";
import { DashboardCreatePage } from "@/pages/project/DashboardCreatePage";
import { createListingData, EMPTY_LISTING_FORM, throwIfRejected, ValidationRejected } from "./listing-form";
import { forgetListings } from "./use-listing";

// SHARE · Ausschreibung anlegen (/share/listings/new): dieselbe Maske wie ein Projekt, mit den Texten
// der Art. Angelegt wird mit Titel und Beschreibung als Entwurf; Frist, Bilder, Leserschaft und
// Mitglieder kommen danach im Dashboard der Ausschreibung.
export function ListingCreatePage() {
  const intl = useIntl();
  const navigate = useNavigate();
  const fallback = useValidationFallback();
  const [createListing, { loading }] = useMutation(CreateListingDocument);
  const [searchTarget, setSearchTarget] = useState<ListingSearchTarget>("PEOPLE");
  const [error, setError] = useState<string | null>(null);

  return (
    <DashboardCreatePage
      kind="LISTING"
      fields={<ListingSearchTargetSelect value={searchTarget} onChange={setSearchTarget} disabled={loading} />}
      saving={loading}
      error={error}
      onCreate={async (draft) => {
        setError(null);
        try {
          // Ohne Standardgruppen und nicht öffentlich: eine Ausschreibung bekommt nur die Leserschaft,
          // die jemand für sie wählt (@external-adr GENESIS-0070-a-listing-is-a-kind-of-project-not-a-shared-item §4).
          const result = await createListing({
            variables: {
              input: {
                data: { ...createListingData({ ...EMPTY_LISTING_FORM, name: draft.title, description: draft.description }), data: { searchTarget } },
                dryRun: false,
              },
            },
            update: forgetListings,
          });
          const payload = result.data?.createListing;
          throwIfRejected(payload, fallback);
          if (payload?.__typename === "CreateListingResult") {
            navigate(`/share/listings/${payload.result.id}`, { replace: true });
          }
        } catch (e) {
          setError(e instanceof ValidationRejected ? e.message : userErrorMessage(intl, e));
        }
      }}
    />
  );
}
